import React from "react";
import styles from "./layout.module.css"
import {Header as MainHeader} from "./header";
import {AppShell} from "@mantine/core";
import {useTypedSelector} from "../store";

type Props = {
  children: React.ReactNode;
};

export const Layout = ({children}: Props) => {
  const {profile} = useTypedSelector((state) => state.auth);

  return (
    <AppShell
      // className={className}
      padding="md"
      header={<MainHeader profile={profile}/>}
      className={styles.layoutSt}
    >
      {children}
    </AppShell>
  );
};
